<template>
<div class="renew container">
  <h1>עליך לחדש את מנויך כדי להכנס</h1>
  <a href="https://yoganow.co.il/%D7%97%D7%99%D7%93%D7%95%D7%A9-%D7%9E%D7%A0%D7%95%D7%99" class="yoga-btn">חדש מנוי</a>
</div>
</template>

<script>
export default {
  name: `Renew`
};
</script>

<style>
</style>
